import type { Environment } from './environment.interface'
import { FeatureFlag } from './environment.interface'

export const environment: Environment = {
  id: 'production',
  production: true,
  apiUrl: 'https://api.denhollander.info',
  keycloak: {
    url: 'https://auth.denhollander.info',
    realm: 'den-hollander-prd',
    clientId: 'den-hollander-portal',
    providers: [
      {
        idpHint: 'oidc',
        enabled: true,
      },
      {
        idpHint: 'rechtsorde',
        enabled: true,
      },
      {
        idpHint: 'li',
        enabled: true,
      },
    ],
  },
  recaptchaSiteKey: '6LfeEIwsAAAAAMMCHI3qDzkconUHUbOVtl4hZsPz',
  flags: [
    FeatureFlag.SUBSCRIPTION_SELF_SERVICE,
    FeatureFlag.SEAT_MANAGEMENT,
    FeatureFlag.KEYCLOAK_INTEGRATION,
  ],
}
